import React, { Component } from 'react';
import QBANKHB from './QuestionBankD.json';
import { Button, Card, CardTitle } from 'reactstrap';
import { Link } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';


class TriviaD extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userAnswer: null,
            currentQuestion: 0,
            answers: [],
            quizEnd: false,
            score: 0,
            disabled: true
        }
    }

    loadTrivia = () => {
        const { currentQuestion } = this.state;
        this.setState(() => {
            return {
                question: QBANKHB[currentQuestion].question,
                answers: QBANKHB[currentQuestion].answers,
                correct: QBANKHB[currentQuestion].correct
            }
        })
    }

    componentDidMount() {
        let dbRef = firebase.database().ref("/user/" + firebase.auth().currentUser.uid)

        dbRef.on('value', (snapshot) => {
            let users = snapshot.val();
            this.setState({
                firstName: users.firstName,
                lastName: users.lastName,
                region: users.region,
                club: users.club,
                rating: users.rating,
                name: users.name,
                scoreHA: users.scoreHA,
                scoreHB: users.scoreHB,
                scoreC: users.scoreC,
                scoreD: users.scoreD
            })
        })
        console.log(this.state)
        this.loadTrivia();
    }

    nextQuestion = () => {

        const { userAnswer, score, correct } = this.state;
        this.setState({ currentQuestion: this.state.currentQuestion + 1 })

        if (userAnswer === correct) {
            this.setState({
                score: score + 1
            })
        }
        console.log(correct)
    }

    componentDidUpdate(preProps, prevState) {
        const { currentQuestion } = this.state;
        if (this.state.currentQuestion !== prevState.currentQuestion) {
            this.setState(() => {
                return {
                    disabled: true,
                    question: QBANKHB[currentQuestion].question,
                    answers: QBANKHB[currentQuestion].answers,
                    correct: QBANKHB[currentQuestion].correct
                }
            })
        }
    }

    checkAnswer = answer => {
        this.setState({
            userAnswer: answer,
            disabled: false
        })
        console.log(this.state.userAnswer)
        console.log(answer)
    }

    finishTrivia = () => {
        if (this.state.currentQuestion === QBANKHB.length - 1) {
            this.setState({
                quizEnd: true
            })
        }
        let tempScore = this.state.score
        if (this.state.userAnswer === this.state.correct) {
            tempScore = tempScore + 1;
            this.setState({
                score: this.state.score + 1
            })
        }

        let dbRef = firebase.database().ref("/user/" + firebase.auth().currentUser.uid)

        dbRef.set({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            region: this.state.region,
            club: this.state.club,
            rating: this.state.rating,
            name: this.state.firstName + ' ' + this.state.lastName,
            scoreHA: this.state.scoreHA,
            scoreHB: this.state.scoreHB,
            scoreC: this.state.scoreC,
            scoreD: tempScore
        })
    }


    render() {

        if (this.state.quizEnd) {
            return (
                <Card>
                    <h1 style={{ textAlign: 'center' }}> Congratulations! </h1>
                    <h2 style={{ textAlign: 'center' }}> You scored a {this.state.score} / {QBANKHB.length} </h2>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Link to='/leaderboard' > <Button> View Leaderboard </Button></Link>
                    </div>
                </Card>
            )
        }
        return (
            <div>
                <Card style={{ padding: '2em' }}>

                    <CardTitle style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '30px' }}>{this.state.question}</CardTitle>
                    <span style={{ textAlign: 'center', paddingBottom: '1em' }}> {`Question ${this.state.currentQuestion + 1} out of ${QBANKHB.length}`} </span>
                    {this.state.answers.map(option => (
                        <Button key={option} color='light' onClick={() => this.checkAnswer(option)} >
                            {option}
                        </Button>
                    ))}
                    {this.state.currentQuestion < QBANKHB.length - 1 && <Button style={{ marginTop: '1em' }} disabled={this.state.disabled} onClick={this.nextQuestion}> Next </Button>}
                    {this.state.currentQuestion === QBANKHB.length - 1 && <Button disabled={this.state.disabled} onClick={this.finishTrivia}> Finish </Button>}
                </Card>
            </div>
        )
    }
}

export default TriviaD;